<template>
  <div>
    <SidebarSearch @submit="patchStatus" title="Atendimento">
      <div class="container">
        <b-tabs content-class="mt-3" nav-class="nav-fill justify-content-center">

          <b-tab title="Em Espera" active>
            <div v-if="senhaAtual" class="col-md-12 card-atendimento em-atendimento card-borda-animada">
              <h4 class="title">Em Atendimento</h4>
              <div class="info-row">
                <div class="info-left">
                  <p><strong>SENHA:</strong> {{ senhaAtual.senhaAtendimento }}</p>
                  <p><strong>NOME:</strong> {{ senhaAtual.pessoa ? senhaAtual.pessoa.nome : 'Não informado' }}</p>
                </div>
                <div class="info-right">
                  <div v-if="senhaAtual.pessoa" class="buttons">
                    <a href="#" @click.prevent="showFollowUpModal(senhaAtual.pessoa.document)" class="text-primary">
                      Detalhes do CRM
                    </a>
                    <a href="#" @click.prevent="showAssociadoModal(senhaAtual.pessoa.document)" class="text-primary">
                      Detalhes do Associado
                    </a>
                  </div>
                  <!-- Botão de finalizar atendimento -->
                  <b-button
                    size="sm"
                    variant="danger"
                    class="mt-2"
                    @click="finalizarAtendimento"
                  >
                    Finalizar Atendimento
                  </b-button>
                </div>
              </div>
            </div>

            <div v-if="senhaAtual && filaEmEspera.length > 0" class="fila-separator">
              <span>Próximos da Fila</span>
              <hr>
            </div>
            <div v-else-if="!senhaAtual && filaEmEspera.length > 0" class="fila-separator-no-current">
              <span>Fila de Espera</span>
              <hr>
            </div>

            <div class="aguardando-list">
              <div
                class="card-atendimento"
                v-for="senha in filaEmEspera" :key="senha.id"
              >
                <h4 class="title">Aguardando</h4>
                <div class="info-row">
                  <div class="info-left">
                    <p><strong>SENHA:</strong> {{ senha.codigo }}</p>
                    <p v-if="senha.nome"><strong>NOME:</strong> {{ senha.nome }}</p>
                    <p v-if="senha.tipo"><strong>TIPO:</strong> {{ senha.tipo }}</p>
                  </div>
                  <div v-if="senha.cooperado" class="info-right">
                    <a href="#" @click.prevent="showAssociadoModal(senha.document)" class="text-primary">
                      Detalhes do Associado
                    </a>
                    <a href="#" @click.prevent="showFollowUpModal(senha.document)" class="text-primary">
                      Detalhes do CRM
                    </a>
                    <br>
                    <b-button
                      size="sm"
                      variant="success"
                      class="mt-2"
                      @click="atenderSenha(senha.id)"
                    >
                      Assumir Atendimento
                    </b-button>
                  </div>
                  <div v-else class="info-right">
                    <p>Não é cooperado</p>
                    <b-button
                      size="sm"
                      variant="success"
                      class="mt-2"
                      @click="atenderSenha(senha.id)"
                    >
                      Assumir Atendimento
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab title="Histórico">
            <div class="aguardando-list">
              <div v-if="historicoSenhas.length > 0">
                <div class="card-atendimento" v-for="(senha, index) in historicoSenhas" :key="index">
                  <h4 class="title">Atendimento Finalizado</h4>
                  <div class="info-row">
                    <div class="info-left">
                      <p><strong>SENHA:</strong> {{ senha.senhaAtendimento }}</p>
                      <p><strong>STATUS:</strong> {{ senha.status }}</p>
                    </div>
                    <div class="info-right">
                      <p v-if="senha.cooperado">
                        <strong>ASSOCIADO:</strong>
                        <a href="#" @click.prevent="showAssociadoModal(senha.document)" class="text-primary">
                          Detalhes do Associado
                        </a>
                        <a href="#" @click.prevent="showFollowUpModal(senha.document)" class="text-primary">
                          Detalhes do CRM
                        </a>
                      </p>
                      <p v-else><strong>ASSOCIADO:</strong> Não é cooperado</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="text-center">Nenhum atendimento concluído ou cancelado encontrado.</p>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </SidebarSearch>

    <AssociadoResumo ref="AssociadoResumo" :document="selectedDocument" />
    <FollowUp
      ref="FollowUp"
      :document="selectedDocument"
      :modal-title="'Detalhes do FollowUp'"
      @close="selectedDocument = null"
    />
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarAtendimento.vue'
import AssociadoResumo from '@/components/nexum/modals/AssociadoResumo.vue'
import FollowUp from '@/components/nexum/components/modals/FollowUp.vue'
import FilaAtendimentoRepository from '@/shared/http/repositories/nxSenhas/fila.js'
import AccountMixin from '@/store/module/account/mixin'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'AtendimentoSenhas',
  mixins: [AccountMixin],
  components: {
    SidebarSearch,
    AssociadoResumo,
    FollowUp
  },
  data () {
    return {
      filaEmEspera: [],
      historicoSenhas: [],
      senhaAtual: null,
      selectedDocument: null,
      socket: null,
      stompClient: null
    }
  },
  methods: {
    async fetchFilaEmEspera () {
      try {
        // Busca a mesa principal do usuário logado
        const mesaPrincipal = this.account.mesas && this.account.mesas.length > 0 ? this.account.mesas[0] : null
        const preferencial = mesaPrincipal && mesaPrincipal.preferencial === true

        let response
        if (preferencial && mesaPrincipal && mesaPrincipal.pa && mesaPrincipal.pa.id) {
          // Se for preferencial, chama o endpoint de preferencial usando pa.id da primeira mesa
          response = await FilaAtendimentoRepository.GetByIdFilaEmEsperaPreferencial(this.account.id, mesaPrincipal.pa.id)
        } else {
          // Caso contrário, chama o endpoint normal
          response = await FilaAtendimentoRepository.GetByIdFilaEmEspera(this.account.id, mesaPrincipal.pa.id)
        }

        let processedFila = response.data.content.map(item => ({
          id: item.id,
          codigo: item.senhaAtendimento,
          nome: item.pessoa ? item.pessoa.nome : 'Não informado',
          document: item.pessoa ? item.pessoa.document : null,
          categoria: item.categoriaAtendimento,
          tipo: item.tipoAtendimento,
          status: item.status,
          cooperado: !!item.pessoa
        }))

        processedFila.sort((a, b) => {
          if (a.tipo === 'PREFERENCIAL' && b.tipo !== 'PREFERENCIAL') {
            return -1
          }
          if (a.tipo !== 'PREFERENCIAL' && b.tipo === 'PREFERENCIAL') {
            return 1
          }
          return 0
        })

        this.filaEmEspera = processedFila
      } catch (error) {
        console.error('Erro ao buscar fila em espera:', error)
      }
    },

    async fetchSenhaAtual () {
      const mesaPrincipal = this.account.mesas && this.account.mesas.length > 0 ? this.account.mesas[0] : null

      try {
        const response = await FilaAtendimentoRepository.GetByIdUltimosChamados(this.account.id, mesaPrincipal.pa.id)
        this.senhaAtual = response.data.find(senha => senha.status === 'EM_ATENDIMENTO') || null
      } catch (error) {
        console.error('Erro ao buscar senha atual:', error)
      }
    },

    async fetchHistorico () {
      const mesaPrincipal = this.account.mesas && this.account.mesas.length > 0 ? this.account.mesas[0] : null

      try {
        const response = await FilaAtendimentoRepository.GetByIdHistorico(this.account.id, mesaPrincipal.pa.id)
        this.historicoSenhas = response.data.map(senha => ({
          id: senha.id,
          senhaAtendimento: senha.senhaAtendimento,
          nome: senha.nome,
          status: senha.status,
          document: senha.pessoa ? senha.pessoa.document : 'Sem documento',
          cooperado: !!senha.pessoa
        }))
      } catch (error) {
        console.error('Erro ao buscar histórico:', error)
      }
    },

    showAssociadoModal (document) {
      if (!document) {
        console.warn('Documento não disponível para este associado.')
        return
      }
      this.selectedDocument = document
      this.$nextTick(() => {
        this.$refs.AssociadoResumo.openResumoAssociado()
      })
    },

    showFollowUpModal (document) {
      if (!document) {
        console.warn('Documento não disponível.')
        return
      }
      this.selectedDocument = document
      this.$nextTick(() => {
        this.$refs.FollowUp.openModal()
      })
    },

    async cancel (id) {
      try {
        await FilaAtendimentoRepository.ChangeStatus(id, 'CANCELADO')
        await this.atualizarDados()
      } catch (error) {
        console.error('Erro ao cancelar senha:', error)
      }
    },

    async patchStatus () {
      try {
        await this.atualizarDados()

        if (this.senhaAtual) {
          await FilaAtendimentoRepository.ChangeStatus(this.senhaAtual.id, 'CONCLUIDO')
        }

        if (this.filaEmEspera.length > 0) {
          const proxima = this.filaEmEspera[0]
          await FilaAtendimentoRepository.ChangeStatus(proxima.id, 'EM_ATENDIMENTO')
        }

        await new Promise(resolve => setTimeout(resolve, 500))

        await this.atualizarDados()
      } catch (error) {
        console.error('Erro no patchStatus:', error)
      }
    },

    async atualizarDados () {
      await Promise.all([
        this.fetchFilaEmEspera(),
        this.fetchSenhaAtual(),
        this.fetchHistorico()
      ])
    },

    connectWebSocket () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`, null, {
        heartbeat: [30000, 30000]
      })
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, () => {
        this.stompClient.subscribe(`/topic/atendimento/novo/${this.account.id}`, (message) => {
          // const data = JSON.parse(message.body)
          this.fetchFilaEmEspera()
        })

        this.stompClient.subscribe('/topic/fila-espera', (message) => {
          this.fetchFilaEmEspera()
        })

        this.stompClient.subscribe('/topic/ultimos-chamados', () => {
          this.fetchSenhaAtual()
          this.fetchHistorico()
        })
      }, (error) => {
        console.error('Erro WebSocket:', error)
      })
    },

    async atenderSenha (id) {
      try {
        if (this.senhaAtual) {
          await FilaAtendimentoRepository.ChangeStatus(this.senhaAtual.id, 'CONCLUIDO')
        }
        await FilaAtendimentoRepository.ChangeStatus(id, 'EM_ATENDIMENTO')
        await this.atualizarDados()
      } catch (error) {
        console.error('Erro ao iniciar atendimento:', error)
      }
    },

    async finalizarAtendimento () {
      try {
        if (this.senhaAtual) {
          await FilaAtendimentoRepository.ChangeStatus(this.senhaAtual.id, 'CONCLUIDO')
          await this.atualizarDados()
        }
      } catch (error) {
        console.error('Erro ao finalizar atendimento:', error)
      }
    }
  },
  watch: {
    'account.id': {
      handler (newVal) {
        if (newVal) {
          this.atualizarDados()
        }
      },
      immediate: true
    }
  },

  mounted () {
    this.connectWebSocket()
    this.atualizarDados()
  }
}
</script>

<style scoped>
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-top: 1.8rem;
  margin-bottom: -1rem;
}

.info-left {
  flex: 1;
  text-align: left;
}

.info-right {
  /* flex: 1; */
  text-align: right;
}

.em-atendimento {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  padding: 20px;
  border: rgba(0, 0, 0, 0.2) 1px solid;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  transition: border-color 0.5s ease-in-out;
  z-index: 10;
}

.card-atendimento {
  background-color: #f8f9fa;
  text-align: center;
  padding: 20px;
  margin-top: 20px;
  border: rgba(0, 0, 0, 0.2) 1px solid;
}

.title {
  margin-bottom: 0.9rem;
  color: #04a791;
  font-size: 1.5rem;
}

.card-borda-animada {
  border: 3px solid #04a791;
  box-shadow: 0 0 10px rgba(4, 167, 145, 0.5);
  animation: border-pulse 1.5s infinite alternate;
}

@keyframes border-pulse {
  0% {
    border-color: #04a791;
    box-shadow: 0 0 10px rgba(4, 167, 145, 0.5);
  }
  50% {
    border-color: #04a791;
    box-shadow: 0 0 15px rgba(4, 167, 145, 0.5);
  }
  100% {
    border-color: #04a791;
    box-shadow: 0 0 10px rgba(4, 167, 145, 0.5);
  }
}

.fila-separator {
  margin-top: 30px;
  text-align: center;
  color: #6c757d;
  font-weight: bold;
  position: relative; /* Adicionado: Para que o z-index do span funcione corretamente */
  z-index: 5; /* Adicionado: Garante que o separador fique abaixo do card sticky, mas acima dos cards da fila */
}

.fila-separator span {
  display: inline-block;
  background-color: #f8f9fa;
  padding: 0 15px;
  position: relative;
  z-index: 1; /* Já existia, mantém o texto acima da própria linha */
}

.fila-separator hr {
  border: none;
  border-top: 2px dashed #ced4da;
  margin-top: -12px;
  position: relative;
  z-index: 0; /* Já existia, mantém a linha abaixo do texto */
}

.fila-separator-no-current {
  margin-top: 20px;
  text-align: center;
  color: #6c757d;
  font-weight: bold;
  position: relative; /* Adicionado */
  z-index: 5; /* Adicionado */
}

.fila-separator-no-current span {
  display: inline-block;
  background-color: #f8f9fa;
  padding: 0 15px;
  position: relative;
  z-index: 1;
}

.fila-separator-no-current hr {
  border: none;
  border-top: 2px dashed #ced4da;
  margin-top: -12px;
  position: relative;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/nxSenhas/atendimento/AtendimentoSenhas.vue